import { createTheme as createTheme$1 } from "@mui/material/styles";
function createTheme(options, ...args) {
  return createTheme$1(
    options,
    args
  );
}
export {
  createTheme
};
//# sourceMappingURL=create-theme.js.map
